import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { GcConnectionComponent } from './component/gc-connection.component';

@NgModule({
  declarations: [
    GcConnectionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    QRCodeModule
  ]
})
export class GcConnectionModule { }
